import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  ClientSelectionLoadOpenChangeRequests,
  ClientSelectionState
} from '../../../state/ClientSelectionState/ClientSelection.state';
import { forkJoin, Observable, Subject } from 'rxjs';
import { ChangeRequestService } from '../../../services/change-request.service';
import { AERequestStatusType } from '../../../models/change-requests';
import { takeUntil } from 'rxjs/operators';
import { ClientTimeOffRequestService } from '../../../services/time-off-request.service';
import { ClientFeatureWhitelistService } from '../../../services/client-feature-whitelist.service';
import { AclService } from '../../../services/acl.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'lib-approvals-tile',
  templateUrl: './approvals-tile.component.html',
  styleUrls: ['./approvals-tile.component.css'],
  standalone: false
})
export class ApprovalsTileComponent implements OnInit, OnDestroy {
  @Select(ClientSelectionState.clientCode)
  clientCode: Observable<string>;
  destroy$ = new Subject<void>();

  requests: any[] = [];

  @Select(ClientSelectionState.canEnableChangeRequests)
  canViewDemographicRequests: Observable<boolean>;
  @Input()
  hasDemographicPermissions = false;
  hasTimeOffPermissions = false;
  timeOffCount: number = 0;
  canEnableTimeOff: boolean = false;
  constructor(
    private store: Store,
    private clientTimeOffService: ClientTimeOffRequestService,
    private clientFeatureWhitelist: ClientFeatureWhitelistService,
    private aclService: AclService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.clientCode.pipe(takeUntil(this.destroy$)).subscribe(code => {
      if (code != null) {
        const userId = this.authService.user.UserId;
        this.aclService.CurrentUserHasMinimumRole('CSR1').subscribe(result => {
          this.hasTimeOffPermissions = result;
          if (result) {
            this.initTimeOff(code);
          } else {
            this.aclService
              .AccessCheck(userId, 'Client Portal Admin', 'timeOff', code)
              .subscribe(clp => {
                this.hasTimeOffPermissions = clp;
                if (clp) {
                  this.initTimeOff(code);
                }
              });
          }
        });
        const obs = [
          this.aclService.AccessCheck(userId, 'Client Portal Admin', 'addressChange', code),
          this.aclService.AccessCheck(userId, 'Client Portal Admin', 'directDepositChange', code),
          this.aclService.CurrentUserHasMinimumRole('CSR1')
        ];
        forkJoin(obs).subscribe(results => {
          this.hasDemographicPermissions = results[0] || results[1] || results[2];
          if (this.hasDemographicPermissions) {
            this.store.dispatch(new ClientSelectionLoadOpenChangeRequests()).subscribe(_ => {
              this.store.selectOnce(ClientSelectionState.getOpenChangeRequests).subscribe(val => {
                this.requests = val;
              });
            });
          }
        });
      }
    });
  }

  private initTimeOff(code: string) {
    if (code != null && this.hasTimeOffPermissions) {
      this.store.selectOnce(ClientSelectionState.canEnableTimeOff).subscribe(canEnable => {
        this.canEnableTimeOff = canEnable;
        if (canEnable) {
          this.clientTimeOffService.getCount(code).subscribe(count => {
            this.timeOffCount = count.Value;
          });
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
